<template>
    <div class="publish_home_div">
        <SideBar></SideBar>
        <postPublish></postPublish>
    </div>
</template>

<script type="text/javascript">
import SideBar from '@/components/posts_page/publish/publish_sidebar.vue'
import postPublish from '@/components/posts_page/publish/post_publish.vue'

export default {
    components: {
        SideBar,
        postPublish
    },
}
</script>
<style type="text/css">
</style>
